var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5399 32.173C53.012 32.173 60.8901 26.1309 66.4181 26.1309C71.946 26.1309 83.5559 29.3619 83.5559 55.2184C83.5559 81.075 67.9373 84.8692 61.8571 84.8692C33.3848 84.8709 21.2226 32.173 41.5399 32.173Z",
    fill: "url(#paint0_linear_390_4193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.599 37.8328C78.01 37.8328 76.7168 36.5179 76.7168 34.9022C76.7168 33.2865 78.01 31.9717 79.599 31.9717C81.1881 31.9717 82.4813 33.2865 82.4813 34.9022C82.4813 36.5179 81.1881 37.8328 79.599 37.8328ZM79.599 33.9254C79.0706 33.9254 78.6383 34.363 78.6383 34.9022C78.6383 35.4414 79.0706 35.8791 79.599 35.8791C80.1275 35.8791 80.5598 35.4414 80.5598 34.9022C80.5598 34.363 80.1275 33.9254 79.599 33.9254Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7109 78.7119H28.3331V77.023H31.7109V78.7119Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4229 78.7119H38.045V77.023H41.4229V78.7119Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5127 84.6221H33.8238V81.2442H35.5127V84.6221Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5117 74.9111H33.8228V71.5333H35.5117V74.9111Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7358 66.377L38.2178 57.1279V74.3117C38.2178 76.1642 39.7363 77.6646 41.6111 77.6646H72.9993C74.8741 77.6646 76.3927 76.1642 76.3927 74.3117V57.1279L58.8746 66.377C57.8906 66.885 56.7199 66.885 55.7358 66.377Z",
    fill: "#F3F3F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9365 51.9594C38.8744 52.5546 38.2178 53.6694 38.2178 54.8748V57.1296L43.3078 59.817V59.7617V50.0684L39.9365 51.9594Z",
    fill: "#F3F3F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.673 51.9594L71.3018 50.0684V59.7617V59.817L76.3917 57.1296V54.8765C76.3917 53.6694 75.7351 52.5562 74.673 51.9594Z",
    fill: "#F3F3F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9984 78.9227H41.6102C39.0363 78.9227 36.9443 76.8556 36.9443 74.3124V54.8738C36.9443 53.2191 37.8487 51.6835 39.3078 50.8637L42.6791 48.9727L43.9346 51.1604L40.5633 53.0515C39.8999 53.4237 39.4893 54.1211 39.4893 54.8738V74.3124C39.4893 75.4675 40.4412 76.408 41.6102 76.408H72.9984C74.1674 76.408 75.1192 75.4675 75.1192 74.3124V54.8738C75.1192 54.1211 74.7086 53.4237 74.0452 53.0515L70.674 51.1604L71.9295 48.9727L75.3008 50.8637C76.7599 51.6835 77.6642 53.2191 77.6642 54.8738V74.3124C77.6642 76.8556 75.5722 78.9227 72.9984 78.9227Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3009 68.0139C56.5594 68.0139 55.8214 67.8396 55.1461 67.4925L37.6162 58.2368L38.8158 56.0205L56.3338 65.2712C56.9344 65.578 57.6691 65.5814 58.2832 65.2645L75.7894 56.0205L76.9889 58.2368L59.4709 67.4875C58.7906 67.8396 58.0457 68.0139 57.3009 68.0139Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5741 59.76H70.0291V37.3858C70.0291 35.816 69.0773 34.5378 67.9083 34.5378H46.7C45.531 34.5378 44.5792 35.816 44.5792 37.3858V59.76H42.0342V37.3858C42.0342 33.9294 44.1262 31.1201 46.7 31.1201H67.9083C70.4821 31.1201 72.5741 33.9294 72.5741 37.3858V59.76Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4805 37.835H66.1305V40.0059H48.4805V37.835Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4805 43.4053H66.1305V45.5762H48.4805V43.4053Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4805 48.9727H66.1305V51.1436H48.4805V48.9727Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4805 54.541H66.1305V56.712H48.4805V54.541Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4193",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4193",
    x1: 57.5001,
    y1: 26.1309,
    x2: 57.5001,
    y2: 84.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1FE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk6);
export default __webpack_public_path__ + "static/media/uwalk6.7374cce19ef57de2b0e5dc58878530e6.svg";
export { ForwardRef as ReactComponent };